const base64url = bytes =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

export const genVerifier = () => {
  const a = new Uint8Array(64);
  window.crypto.getRandomValues(a);
  return base64url(a);
};

export const challenge = async verifier => {
  const buf = await window.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );
  return base64url(new Uint8Array(buf));
};
